interface SpinnerProps {
  readonly size?: 'sm' | 'md' | 'lg'
  readonly label?: string
}

const SIZE: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]'
}

export function Spinner({ size = 'md', label = 'Loading' }: SpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block rounded-full border-forest border-t-transparent animate-spin ${SIZE[size]}`}
    />
  )
}
